module.exports = __webpack_public_path__ + "img/58.7043c66e.jpg";